/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Create_HelperInputs */

const en_us2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It starts with the equipment ticked in your profile now. You can change it later.`)
};

const pt_br2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela começa com os equipamentos marcados no seu perfil agora. Dá para mudar depois.`)
};

const es_419_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza con el equipo marcado ahora en tu perfil. Puedes cambiarlo después.`)
};

const pt_pt2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa com o equipamento marcado agora no teu perfil. Podes alterá-lo depois.`)
};

const fr_fr2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle démarre avec l'équipement coché dans ton profil. Tu pourras le changer plus tard.`)
};

const de_de2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es startet mit der Ausstattung, die gerade in deinem Profil markiert ist. Du kannst sie später ändern.`)
};

const it_it2_gyms_create_helper = /** @type {(inputs: Gyms_Create_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte con l'attrezzatura selezionata ora nel tuo profilo. Puoi cambiarla dopo.`)
};

/**
* | output |
* | --- |
* | "It starts with the equipment ticked in your profile now. You can change it later." |
*
* @param {Gyms_Create_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_create_helper = /** @type {((inputs?: Gyms_Create_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Create_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_create_helper(inputs)
	if (locale === "es-419") return es_419_gyms_create_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_create_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_create_helper(inputs)
	if (locale === "de-DE") return de_de2_gyms_create_helper(inputs)
	if (locale === "it-IT") return it_it2_gyms_create_helper(inputs)
	return en_us2_gyms_create_helper(inputs)
});
export { gyms_create_helper as "gyms.create_helper" }